import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";

@Injectable()
export class SessionDataService_Generic {

  private setCurrencySessionDataUrl = `${this.restUrlsConf.appURL}/public/price/set_item_price.json`;

  constructor(protected http: HttpClient,
              protected restUrlsConf: RestUrlsConfig) { }

  setProductPrice(params): Observable<any> {
    return this.http.post(this.setCurrencySessionDataUrl, JSON.stringify(params))
        .pipe(tap((res: HttpResponse<any>) => res, (error: any) => throwError(error)));
  }
}
